<template>
  <div>
    <Loading v-if="requested" />
    <TopNavbar :bgColor="'bg-main'" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <van-icon name="arrow-left" class="icon" @click="arrowLeft" />
      <div class="flex1">
        <div class="flex justify-between">
          <label>My Address Detail</label>
        </div>
      </div>
    </TopNavbar>
    <ChooseFeature v-if="isSubmit" 
      :confirm="confirmSave"
      :cancel="cancelSave"
      :store="delivery_current_storeinfo"
      :serviceType="serviceType"
      :disableOption="disableOption" />
    <div class="container" v-if="!requested" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <div class="address-detail-data">
        <van-form>
          <div class="address-map">
            <div class="map-wapper">
              <div>
                <gmap-map :center="center" :zoom="16" style="width:100%;  height: 250px;" :options='{ fullscreenControl: false, mapTypeControl: false, rotateControl: false, scaleControl: false, streetViewControl: false }'>
                  <gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :draggable="true" @dragend="updateMaker" @click="center=m.position">
                  </gmap-marker>
                </gmap-map>
              </div>
            </div>
          </div>
          <div class="address-detail">
            <div class="field-group" v-if="isLogin">
              <van-cell center title="Default Address">
                <template #right-icon>
                  <van-switch v-model="form.is_default" size="20" active-color="#EE2D24" :class="isSubmit? 'hideVisibility':'showVisibility'"/>
                </template>
              </van-cell>
            </div>

            <div class="field-group">
              <label class="field-title"><span style="color: red">*</span> Search Address (Condo Name, Jalan, Taman)</label>
              <div class="van-cell van-field" v-bind:class="{ active: isAddressValid, inactive: !isAddressValid }">
                <div class="van-cell__value van-cell__value--alone van-field__value" style="width: 100%">
                  <div class="van-field__body">
                    <gmap-autocomplete class="gmap-input-field van-field__control" ref="addressInput" placeholder="e.g. Pavilion Residence, Jalan Sultan Ismail, Taman Gembira, etc" autocomplete="off" right-icon="success" :value="form.address" @input="validateAddress" @place_changed="setPlace" cancelable="true" @click.right.prevent @copy.prevent @paste.prevent>
                    </gmap-autocomplete>
                    <div class="van-field__right-icon">
                      <van-icon name="success" color="green" v-if="isAddressValid"/>
                      <van-icon name="cross" color="red" v-if="!isAddressValid" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="field-group">
              <label class="field-title"><span style="color: red">*</span> Unit/Floor</label>
              <van-field v-model="form.address2" name="Unit/Floor" placeholder="e.g. Floor, unit number" autocomplete="off" @input="validateAddress2" v-bind:class="{ active: isAddress2Valid, inactive: !isAddress2Valid }">
                <template slot="right-icon" v-if="isAddress2Valid">
                  <van-icon name="success" color="green" />
                </template>
                <template slot="right-icon" v-if="!isAddress2Valid">
                  <van-icon name="cross" color="red" />
                </template>
              </van-field>
            </div>

            <div class="field-group">
              <label class="field-title"><span style="color: red">*</span> Name</label>
              <van-field v-model="form.name" name="Address Label" placeholder="e.g. Home / Office" autocomplete="off" @input="validateAddressLabel" v-bind:class="{ active: isAddressLabelValid, inactive: !isAddressLabelValid }">
                <template slot="right-icon" v-if="isAddressLabelValid">
                  <van-icon name="success" color="green" />
                </template>
                <template slot="right-icon" v-if="!isAddressLabelValid">
                  <van-icon name="cross" color="red" />
                </template>
              </van-field>
            </div>

            <div class="field-group">
              <label class="field-title"><span style="color: red">*</span> Contact Name</label>
              <van-field v-model="form.nickname" name="Contact Name" placeholder="Contact Name" autocomplete="off" @input="validateNameInput" v-bind:class="{ active: isNameValid, inactive: !isNameValid }">
                <template slot="right-icon" v-if="isNameValid">
                  <van-icon name="success" color="green" />
                </template>
                <template slot="right-icon" v-if="!isNameValid">
                  <van-icon name="cross" color="red" />
                </template>
              </van-field>
            </div>

            <div class="field-group">
              <label class="field-title"><span style="color: red">*</span> Contact Number</label>
              <div class="van-cell van-field" v-bind:class="{ active: isMobileValid, inactive: !isMobileValid }" >
                <div class="van-cell__value van-cell__value--alone van-field__value" style="width: 100%">
                  <div class="van-field__body">
                    <vue-tel-input
                      class="van-field__control"
                      v-model="form.mobile" 
                      defaultCountry='MY'
                      mode='international'
                      autocomplete="off" 
                      :onlyCountries="allowCountries"
                      @validate="validateMobileInput">
                    </vue-tel-input>
                    <div class="van-field__right-icon">
                      <van-icon name="success" color="green" v-if="isMobileValid" />
                      <van-icon name="cross" color="red" v-if="!isMobileValid" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </van-form>

        <div class="address-remove-tags" v-if="parseInt(form.address_id) > 0">
          <a @click="removeAddress">Remove</a>
        </div>
      </div>
    </div>

    <div class="fixed footer" v-if="!requested" :class="isSubmit? 'hideVisibility':'showVisibility'">
      <div class="container">
        <van-button type="primary" block @click="saveAddress" :disabled="!isAddressLabelValid || !isAddressValid || !isAddress2Valid || !isNameValid || !isMobileValid">Save Address</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getAddressInfo, delAddressInfo, saveAddressInfo, getDeliveryQuotation, getGoogleMapLocationPlace, getDeliveryOption } from '@/api/api'
import { cartMixin } from '@/mixins/cartMixin'
import { mapGetters, mapActions } from 'vuex'
import TopNavbar from '@/components/common/TopNavbar.vue'
import Loading from '@/components/common/Loading.vue'
import ChooseFeature from '@/components/common/ChooseFeature.vue'
import { Dialog } from 'vant'

export default {
  name: 'addressInfo',
  components: { TopNavbar, Loading, ChooseFeature },
  data () {
    return {
      requested: false,
      isLogin: false,
      isAddressLabelValid: false,
      isAddressValid: false,
      isAddress2Valid: false,
      isNameValid: false,
      isMobileValid: false,
      isSubmit: false,
      serviceType: {},
      form: {
        address_id: 0,
        is_default: false,
        state: '',
        province: [],
        city: '',
        zipcode: '',
        address: '',
        address2: '',
        address3: '',
        nickname: '',
        country: '',
        name: '',
        mobile: '',
        lat: null,
        lng: null
      },
      disableOption: false,
      center: { lat: 3.139003, lng: 101.686855 },
      markers: [],
      currentPlace: null,
      allowCountries: ['MY', 'SG', 'ID'],
    };
  },
  created () {
    const queryParams = this.$route.query
    this.form.address_id = queryParams && queryParams.address_id || 0
    this.isLogin = queryParams && queryParams.is_login || false

    if (parseInt(this.form.address_id) > 0) {
      this.get_data()
    }

    if (this.delivery_current_address && this.delivery_current_address.address_id != undefined) {
      this.form = this.delivery_current_address
      this.form.address = this.delivery_current_address.address

      const marker = {
        lat: this.delivery_current_address.lat,
        lng: this.delivery_current_address.lng
      };
      console.log('marker location >>>', marker);
      console.log('marker store >>>', this.delivery_current_storeinfo.location.lat,', ',this.delivery_current_storeinfo.location.lng)
      let distance = this.calcCrow(this.form.lat,this.form.lng,Number(this.delivery_current_storeinfo.location.lat),Number(this.delivery_current_storeinfo.location.lng)).toFixed(1);
      console.log('Distance between store and location',distance)
      if (distance > 20){
        this.disableOption = true;
      } else {
        this.disableOption = false;
      }
      this.form.lat = marker.lat
      this.form.lng = marker.lng
      this.markers = [];
      this.markers.push({ position: marker });
      this.center = marker;
    }

    this.validateForm();
  },
  computed: {
    ...mapGetters(["delivery_current_address", "delivery_current_storeinfo", "user_islogin", "user_detail", "lalamove_list", "easyparcel_list","teleport_list"])
  },
  mixins: [cartMixin],
  mounted () {
    console.log('mounted google map...');
    if (parseInt(this.form.address_id) == 0) {
      //this.geolocate();
    }
  },
  methods: {
    ...mapActions({
      saveCurrentAddress: "delivery/settingCurrentAddress",
      saveLalamoveList: "delivery/settingLalamoveList",
      saveEasyparcel: "delivery/settingEasyparcel",
      saveTeleport: "delivery/settingTeleport",
      saveDelyva: "delivery/settingDelyva",
      saveTadago: "delivery/settingTadago",
    }),
    arrowLeft () {
      window.history.back(-1)
    },
    dialogMessage (text, isBack) {
      Dialog({
        message: text,
        confirmButtonText: 'Confirm'
      }).then(() => {
        if (isBack) {
          this.arrowLeft()
        }
      });
    },
    geolocate: function () {
      const options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 30000
      }
      navigator.geolocation.getCurrentPosition(position => {
        console.log('position >>>', position);
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        };
        this.getAddress(this.center.lat, this.center.lng)
        this.markers.push({ position: this.center })
      }, null, options);
    },
    /**
     * 获取地址详情
     */
    async get_data () {
      this.requested = true
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_user_address_info' })
      getAddressInfo('/app/index.php', queryParams).then(res => {
        this.form = res.data
        this.form.address = res.data.address
        const marker = { lat: parseFloat(res.data.lat), lng: parseFloat(res.data.lng) }
        this.center = marker
        this.markers = [];
        this.markers.push({ position: marker });
        this.requested = false
        this.isLogin = res.data.is_login

        this.validateForm();
      }).catch(error => {
        this.$toast('network timeout')
        this.requested = false
      })
    },
    saveAddress () {
      console.log('***** Save address [%s] ****', JSON.stringify(this.form));
      console.log('***** user_islogin [%s] *****', this.user_islogin);
      console.log('***** isLogin [%s] *****', this.isLogin);   
      console.log('***** isAddressLabelValid [%s] *****', this.isAddressLabelValid);
      console.log('***** isAddressValid [%s] *****', this.isAddressValid);
      console.log('***** isAddress2Valid [%s] *****', this.isAddress2Valid);
      console.log('***** isNameValid [%s] *****', this.isNameValid);
      console.log('***** isMobileValid [%s] *****', this.isMobileValid);


      const getOption = () => {
          const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'getDeliveryOption' })
          const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
          getDeliveryOption('/app/index.php?' + suffixQuery, {store: this.delivery_current_storeinfo, form: this.form })
              .then(res => {
                  console.log('res from delivery option',res)
                  this.serviceType = res.data.deliveryOption;
                  if (!this.isSubmit){
                      if (!this.form.name) {
                        this.dialogMessage("Address Label is required. Please type label for your address e.g. Home / Office", false)
                        return
                      }

                      if (!this.form.address || this.markers.length == 0 || !this.form.lat || !this.form.lng) {
                        this.dialogMessage("Not able to detect your location coordinate with your address, please try again with nearby location name by GOOGLE MAP suggestion (e.g. Jalan Sultan Ismail).", false)
                        return
                      }

                      if (!this.form.address2) {
                        this.dialogMessage("Unit / Floor is required. Please type unit / floor number e.g. No. 1, Block A", false)
                        return
                      }

                      if (!this.form.nickname) {
                        this.dialogMessage("Contact Name is required. Please type contact name", false)
                        return
                      }

                      if (!this.form.mobile) {
                        this.dialogMessage("Contact Number is required. Please type contact phone", false)
                        return
                      } else {
                        if(!this.isMobileValid) {
                          this.dialogMessage("Invalid Contact Number format. Please enter a valid contact phone", false)
                          return
                        }
                      }
                      console.log('current store info => ',this.delivery_current_storeinfo, ' this form => ',this.form)
                      if (this.delivery_current_storeinfo.is_rain == 1){
                          this.dialogMessage('The merchant is on raining mode. All the bike delivery service will be disabled and should be expecting some delay for the order',false)
                      }
                      if (this.serviceType.delivery_service == 'teleport'){
                          if (this.serviceType.service_type.length > 1){
                              this.saveCurrentAddress(this.form)
                              this.requested = false;
                              this.isSubmit = true;
                          } else if (this.serviceType.service_type.length == 1) {
                              if (this.serviceType.service_type[0] == 'STANDARD'){
                                  this.serviceType.choosedService = 'STANDARD_24';
                              } else {
                                  this.serviceType.choosedService = this.serviceType.service_type[0];
                              }
                              this.saveCurrentAddress(this.form)
                              this.requested = true;
                              this.confirmSave();
                          }
                      } else if (this.serviceType.delivery_service == 'lalamove'){
                          if (this.serviceType.service_type.length > 1){
                              this.saveCurrentAddress(this.form)
                              this.requested = false;
                              this.isSubmit = true;
                          } else if (this.serviceType.service_type.length == 1) {
                              this.serviceType.choosedService = this.serviceType.service_type[0];
                              this.saveCurrentAddress(this.form)
                              this.requested = true;
                              this.confirmSave();
                          }
                      } else {
                          this.saveCurrentAddress(this.form)
                          this.requested = true;
                          this.confirmSave();
                      }
                  }
              })
              .catch(error => {
                // console.log('添加到购物车.error', error);
              });
      };
      getOption();
    },
    
    confirmSave(){     
      if (this.user_islogin || this.isLogin) {
        //已登录，则请求保存地址的api接口
        const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'save_user_address_info' })
        const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
        saveAddressInfo('/app/index.php?' + suffixQuery, this.form).then(res => {
          console.log('接口返回数据>>>', res.data);
          this.saveCurrentAddress(res.data)
          this.dialogMessage(res.msg, res.status)
        }).catch(error => {
          this.requested = false
          this.dialogMessage(error.msg, false)

          return;
        })
      }
      
      const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_delivery_quotation' })
      const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&")
      getDeliveryQuotation('/app/index.php?' + suffixQuery, {serviceType:this.serviceType , store: this.delivery_current_storeinfo, address: this.form }).then(res => {
        this.form['quotation'] = res.data
        this.requested = false
        this.isSubmit = false

        if(res.data) {
          if (res.data.store_delivery_service_type === 1) {
            this.dialogMessage(res.msg, res.status)
          }
          if (res.data.store_delivery_service_type === 2) {
            this.dialogMessage(res.msg, res.status)
            this.saveLalamoveList(res.data.ship_data_list)
          }
          if (res.data.store_delivery_service_type === 3) {
            this.saveEasyparcel(res.data.ship_data_list)
            this.$router.push( { path: "/delivery/shipment", query: { "address_id": 0 } });
          }
          if (res.data.store_delivery_service_type === 5) {
            this.dialogMessage(res.msg, res.status)
          }
          if (res.data.store_delivery_service_type === 6) {
            this.dialogMessage(res.msg, res.status)
            this.saveTeleport(res.data.deliveryOption)
          }
          if (res.data.store_delivery_service_type === 7) {
            if (this.serviceType.choosedService == undefined){
                if (res.data.servicePartners.length == 0){
                    this.dialogMessage('Oops, the location is currently out of delivery partner coverage area. Please check the address respectively or try another location again.',false)
                } else {
                    this.serviceType.servicePartners = res.data.servicePartners;
                    this.serviceType.etaInMinute = res.data.etaInMinute
                    this.requested = false;
                    this.isSubmit = true;
                }
            } else {
                this.saveDelyva(res.data.deliveryOption)
                this.dialogMessage(res.msg, res.status)
            }
          }
          if (res.data.store_delivery_service_type === 8) {
            if (this.serviceType.choosedService == undefined){
                if (res.data.servicePartners.length == 0){
                    this.dialogMessage('Oops, the location is currently out of delivery partner coverage area. Please check the address respectively or try another location again.',false)
                } else {
                    this.serviceType.servicePartners = res.data.servicePartners;
                    this.serviceType.etaInMinute = res.data.etaInMinute
                    this.requested = false;
                    this.isSubmit = true;
                }
            } else {
                this.saveTadago(res.data.deliveryOption)
                this.dialogMessage(res.msg, res.status)
            }
          }
        } else {
          this.dialogMessage(res.msg, false)
        }
      }).catch(error => {
        this.requested = false
        this.dialogMessage(error.msg, false)
        console.error('Exception handler during getDeliveryQuotation.', JSON.stringify(error));
      })
    },
    cancelSave() {
      this.isSubmit=false;
    },
    removeAddress() {
      Dialog.confirm({
        title: 'Remove "' + this.form.name + '"',
        message: 'Are you confirm to remove this address permanently from your address list?',
        confirmButtonText: 'Remove',
        confirmButtonColor: '#EE2D24',
        cancelButtonText: 'Cancel'
      }).then(() => {
        const queryParams = this.getUrlParams({ i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'del_user_address_info' })
        const suffixQuery = Object.keys(queryParams).map(key => encodeURIComponent(key) + "=" + encodeURIComponent(queryParams[key])).join("&");
        delAddressInfo('/app/index.php?' + suffixQuery, this.form).then(res => {
          this.$toast(res.msg)
          if (res.code == 200) {
            this.dialogMessage(res.msg, true)
          }
        }).catch(error => {
          this.dialogMessage('Delete Address Failed', false)
          console.error('Exception handler during removeAddress.', error);
        });
      });
    },
    resetFormLatlng (position) {
      const { lat, lng } = position
      this.form.lat = lat || 3.0877750000
      this.form.lng = lng || 101.6368620000
    },
    // --------------------------------------- map
    setPlace (place) {
      console.log('place >>>', place);
      this.currentPlace = place

      let suburb = '', city = '', province = {}, country = '', postal_code = ''
      place && place.address_components.forEach(element => {
        const { long_name, short_name, types } = element
        console.log('>>> types', element, types[0]);
        if (types[0] == 'sublocality_level_1') {
          suburb = long_name // 行政区名
        } else if (types[0] == 'locality') {
          city = long_name // city
        } else if (types[0] == 'administrative_area_level_1') {
          province = element // province
        } else if (types[0] == 'country') {
          country = long_name // county
        } else if (types[0] == 'postal_code') {
          postal_code = long_name // zipcode
        }
      });

      this.form.address = this.$refs.addressInput.$el.value;
      this.form.city = city
      this.form.province = province
      this.form.state = province.long_name
      this.form.country = country
      this.form.zipcode = postal_code
      this.addMarker();
    },
    addMarker () {
      if (this.currentPlace) {
        const marker = {
          lat: this.currentPlace.geometry.location.lat(),
          lng: this.currentPlace.geometry.location.lng()
        };
        this.form.lat = marker.lat
        this.form.lng = marker.lng
        console.log('marker >>>', marker);
        if (!this.isLogin){
            console.log('marker store >>>', this.delivery_current_storeinfo.location.lat,', ',this.delivery_current_storeinfo.location.lng)
            let distance = this.calcCrow(this.form.lat,this.form.lng,Number(this.delivery_current_storeinfo.location.lat),Number(this.delivery_current_storeinfo.location.lng)).toFixed(1);
            console.log('Distance between store and location',distance)
            if (distance > 20){
              this.disableOption = true;
            } else {
              this.disableOption = false;
            }
        }
        this.markers = [];
        this.markers.push({ position: marker });
        this.center = marker;
        this.isAddressValid = true;
        //this.currentPlace = null;
      }
    },
    //This function takes in latitude and longitude of two location and returns the distance between them as the crow flies (in km)
    calcCrow(lat1, lon1, lat2, lon2) 
    {
      var R = 6371; // km
      var dLat = this.toRad(lat2-lat1);
      var dLon = this.toRad(lon2-lon1);
      var dlat1 = this.toRad(lat1);
      var dlat2 = this.toRad(lat2);

      var a = Math.sin(dLat/2) * Math.sin(dLat/2) +
        Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(dlat1) * Math.cos(dlat2); 
      var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a)); 
      var d = R * c;
      return d;
    },

    // Converts numeric degrees to radians
    toRad(Value) 
    {
        return Value * Math.PI / 180;
    },
    updateMaker: function (event) {
      console.log('updateMaker new latitude, ', event.latLng.lat());
      console.log('updateMaker new longitude, ', event.latLng.lng());
      // this.$emit("evtResetLatlng", { lat: event.latLng.lat(), lng: event.latLng.lng() })
      this.resetFormLatlng({ lat: event.latLng.lat(), lng: event.latLng.lng() })

      this.markers[0].position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      }
      this.addMarker();
      const theLocations = { lat: event.latLng.lat(), lng: event.latLng.lng() }
    },
    getAddress (lat, lng) {
      try {
        const queryParams = { i: 2, c: 'entry', m: 'weisrc_dish', append: 1, mode: 2, do: 'get_location_place', lat: lat, lng: lng }
        getGoogleMapLocationPlace('/app/index.php', queryParams).then(res => {
          console.log('getGoogleMapLocationPlace -------->>> ', [queryParams, res])
          this.form.address = res.data.formatted_address || ''

          const province = res.data && res.data.address_components.filter(d => d.types.some(c => {
            return c == "administrative_area_level_1";
          })).map(r => { return r });
          this.form.province = province[0]
          this.form.state = province[0]['short_name']
          console.log('province-2 >>>', province)

          if (res.status == false) {
            console.log('获取地址失败# Err >>> ', res.msg)
          }
        }).catch(error => {
          this.$toast('network timeout')
          this.requested = false
        })

      } catch (error) {
        console.log(error.message);
      }
    },
    validateForm() {
      this.validateAddressLabel();
      this.validateAddress();
      this.validateAddress2();
      this.validateNameInput();
    },
    validateAddressLabel() {
      if (this.form.name) {
        this.isAddressLabelValid = true;
      } else {
        this.isAddressLabelValid = false;
      }
    },
    validateAddress() {
      if(this.$refs.addressInput !== undefined) {
        this.form.address = this.$refs.addressInput.$el.value;
      }

      if(!this.form.address) {
          this.form.lat = null;
          this.form.lng = null;
          this.markers = [];
      }

      if(this.form.address && this.form.lat && this.form.lng) {
        this.isAddressValid = true;
      } else {
        this.isAddressValid = false;
      }
    },
    validateAddress2() {
      if(this.form.address2) {
        this.isAddress2Valid = true;
      } else {
        this.isAddress2Valid = false;
      }
    },
    validateNameInput() {
      if(this.form.nickname) {
        this.isNameValid = true;
      } else {
        this.isNameValid = false;
      }
    },
    validateMobileInput({ number, isValid, country }) {
      this.isMobileValid = isValid;
    }
  }
};
</script>
<style lang="less">
@import url('../../assets/css/common.less');
body {
  background-color: #eeeeee;
}
.bgRed {
  background-color: @red !important;
}
.container {
  .my-address {
    padding: 0 16px;

    .my-address-label {
      width: 90px;
      flex-basis: 90px;
    }
    .gmap-input-field {
      width: 90%;
      margin: 10px 0;
      padding: 5px 0px;
      border: 0;
    }
  }

  .address-detail-data {
    padding-top: 36px;
    padding-bottom: 10vh;
    text-align: left;
    font-size: 12px;

    .address-map {
      background-color: white;
    }
    .address-detail {
      padding: 6px 0;
      padding-bottom: 12px;
      background-color: white;
      margin: 0 0 10px 0;
    }
  }

  .field-group {
    border-bottom: 1px solid #eee;
    margin: 10px 16px;
  }

  .field-title {
    font-size: 12px;
    font-weight: bolder;
  }

  .van-cell {
    border: none;
    padding: 6px 0;
  }

  .van-field__label {
    width: auto;
    font-size: 10px;
    padding-right: 16px;
  }

  .van-field__control {
    font-size: 14px !important;
  }

  .vue-tel-input {
    border: none;
  }

  .vti__dropdown {
    padding-left: 0;
    padding-top: 0;
    padding-bottom: 0;
  }

  .address-remove-tags {
    padding: 16px;
    background-color: white;

    a {
      color: @red !important;
    }
  }
}

.active {
  border-bottom: 1px solid green !important;
  border-radius: 0 !important;
}

.inactive {
  border-bottom: 1px solid red !important;
  border-radius: 0 !important;
}

.footer {
  z-index: 1000;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: white;

  .container {
    padding: 16px;

    button {
      background-color: @main !important;
      border: 1px solid @main;
    }
  }
}
  .hideVisibility {
    z-index: -1;
  }

  .showVisibility {
    z-index: 1;
  }
</style>